import {
  BeaconOfNagashizzar,
  ChorusOfTerror,
  CloakedInShadow,
  DeathStalkers,
  Ethereal,
  NighthauntSlasherHost,
  ShadowSEdge,
  SoulfireRing,
  WaveOfTerror
} from "whole-shared";

import type { ClientAbility } from "../../rules";
import type { ClientSpearheadArmy } from "./rules";

export const ClientWaveOfTerror: ClientAbility = {
  ...WaveOfTerror,
  declare:
    "Pick a friendly unit to use this ability if it charged this phase and the charge roll was 10+. Then, pick an enemy unit within 1\" of it to be the target",
  description: "Many foes freeze in fear when faced by a swarming Nighthaunt charge",
  effect:      (
    <>
      The target has <b>STRIKE-LAST</b> this turn
    </>
  ),
  name: "WAVE OF TERROR"
};

export const ClientEthereal: ClientAbility = {
  ...Ethereal,
  description: "Nighthaunt spirits can only be harmed by blows delivered with great conviction",
  effect:      "Ignore all modifiers to save rolls for friendly units (positive and negative)",
  name:        "ETHEREAL"
};

export const ClientSoulfireRing: ClientAbility = {
  ...SoulfireRing,
  description: "Gouts of lashing green names leap forth from this ring as it consumes the souls of those slain by the wearer",
  effect:      (
    <>
      If any models were slain by your general this turn, <b>Heal (D6)</b> your general
    </>
  ),
  name: "SOULFIRE RING"
};

export const ClientCloakedInShadow: ClientAbility = {
  ...CloakedInShadow,
  description: "Eerily intangible, this spirit's ethereal form fades in and out of existence like some wispy cloud of supernatural mist",
  effect:      "No more than 1 enemy unit can target your general with attacks (shooting or combat) per phase",
  name:        "CLOAKED IN SHADOW"
};

export const ClientBeaconOfNagashizzar: ClientAbility = {
  ...BeaconOfNagashizzar,
  description: "This malignant light summons departed soul",
  effect:      "Return 1 slain model to each friendly unit on the battlefield",
  name:        "BEACON OF NAGASHIZZAR"
};

export const ClientShadowSEdge: ClientAbility = {
  ...ShadowSEdge,
  description: "It is impossible to tell if this ebon blade is corporeal or mere shadow, yet its touch tears through flesh and bone with ease",
  effect:      (
    <>
      Your general's <b>Sword of Stolen Hours</b> has <b>Crit (Mortal)</b>
    </>
  ),
  name: "SHADOW'S EDGE"
};

export const ClientDeathStalkers: ClientAbility = {
  ...DeathStalkers,
  declare:     "Pick an enemy unit on the battlefield",
  description: "These spectral killers relentlessly hunt down quarry whose names have been whispered to them in darksome rites",
  effect:      "Add 1 to the Rend characteristic of melee weapons used for attacks that target that unit",
  name:        "DEATH STALKERS"
};

export const ClientChorusOfTerror: ClientAbility = {
  ...ChorusOfTerror,
  description: "Warriors are frozen in place by the shrieks of the Nighthaunt as they wash over the enemy lines in a wave of terror",
  effect:      "Subtract 1 from hit rolls for combat attacks that target a friendly unit that charged in the same turn",
  name:        "CHORUS OF TERROR"
};

export const ClientNighthauntSlasherHost: ClientSpearheadArmy = {
  ...NighthauntSlasherHost,
  battleTraits:      [ClientWaveOfTerror, ClientEthereal],
  enhancements:      [ClientSoulfireRing, ClientCloakedInShadow, ClientBeaconOfNagashizzar, ClientShadowSEdge],
  name:              "SLASHER HOST",
  regimentAbilities: [ClientDeathStalkers, ClientChorusOfTerror]
};
